import { UserData, UserValidationError } from '@/school-management/types/user-data';

const validateEmail = (email: string): boolean => {
  const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return pattern.test(email) && isWithinLength(email, 255);
};

const standardPattern =
  /^[-A-Za-z\s'"\u2013.,\u0590-\u05FF\u00C0-\u00FF\u0100-\u01FF\u0200-\u02AF]+$/;
const googlePattern =
  /^[-A-Za-z0-9\s'"\u2013.,\u0590-\u05FF\u00C0-\u00FF\u0100-\u01FF\u0200-\u02AF]+$/;

const isValidName = (name: string, isGoogle?: boolean): boolean => {
  const pattern = isGoogle ? googlePattern : standardPattern;
  return pattern.test(name);
};

const isWithinLength = (name: string, maxLength: number): boolean => {
  return name.length <= maxLength;
};

export const validateFirstName = (
  firstName: string,
  isGoogle?: boolean
): UserValidationError | null => {
  if (!firstName) {
    return { field: 'firstName', message: 'first_name_missing' };
  }

  if (!isValidName(firstName, isGoogle)) {
    return { field: 'firstName', message: 'first_name_incorrect' };
  }

  if (!isGoogle && !isWithinLength(firstName, 30)) {
    return { field: 'firstName', message: 'first_name_too_long' };
  }

  return null;
};

export const validateLastName = (
  lastName: string,
  isGoogle?: boolean
): UserValidationError | null => {
  if (!lastName) {
    return { field: 'lastName', message: 'last_name_missing' };
  }

  if (!isValidName(lastName, isGoogle)) {
    return { field: 'lastName', message: 'last_name_incorrect' };
  }

  if (!isGoogle && !isWithinLength(lastName, 40)) {
    return { field: 'lastName', message: 'last_name_too_long' };
  }

  return null;
};

const ValidateUser = (user: UserData): UserValidationError[] => {
  const errors: UserValidationError[] = [];

  const firstNameValidation = validateFirstName(user.firstName);
  if (firstNameValidation) {
    errors.push(firstNameValidation);
  }

  const lastNameValidation = validateLastName(user.lastName);
  if (lastNameValidation) {
    errors.push(lastNameValidation);
  }

  if (!user.email || !validateEmail(user.email)) {
    errors.push({ field: 'email', message: 'email_incorrect' });
  }

  return errors;
};

export default ValidateUser;
